/*
 * @Author: Dieu-Donne Nazzah
 * @Date: 2020-06-08 18:33:51
 * @Last Modified by: Dieu-Donne Nazzah
 * @Last Modified time: 2022-01-10 04:10:07
 */
import React from 'react';

const Projects = ({ data, otherData }) => {
	return (
		<React.Fragment>
			<section className="section project" id="projects-section">
				<div className="container">
					<div className="row justify-content-center pb-5">
						<div
							className="col-md-12 heading-section text-center"
							data-aos="fade-up"
						>
							<h1 className="big big-2">Projects</h1>
							<h2 className="mb-4">Projects</h2>
							<p>
								Somewhere in Accra, in the great nation of Ghana
							</p>
						</div>
					</div>
					<div className="row">
						{data.map((project, index) => (
							<div
								className={`col-12 d-md-flex my-5 ${
									index % 2 !== 0 ? 'flex-md-row-reverse' : ''
								}`}
								key={project.id}
							>
								<div
									className="img"
									style={{
										backgroundImage: `url(${project.image})`,
									}}
									data-aos={
										index % 2 === 0
											? 'fade-up-right'
											: 'fade-up-left'
									}
								></div>
								<div
									className={`text ${
										index % 2 !== 0
											? 'text-left'
											: 'text-right'
									}`}
								>
									<span className="feature">
										Featured Project
									</span>
									<h3 className="py-2">
										<a
											href={project.link}
											target="_blank"
											rel="noopener noreferrer"
										>
											{project.name}
										</a>
									</h3>
									<div className="description p-3 mt-2 mb-4">
										{project.description}
									</div>
									<span>{project.tech}</span>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			<section
				className="pb-5"
				id="other-projects"
				style={{ marginBottom: 80 }}
			>
				<div className="container">
					<div className="row justify-content-center pb-5 mt-5">
						<div
							className="col-md-12 heading-section text-center"
							data-aos="fade-up"
						>
							<h3 className="big big-2">Other Projects</h3>
							<p>
								Somewhere in Accra, in the great nation of Ghana
							</p>
						</div>
					</div>
					<div className="row">
						{otherData.map((project) => (
							<div
								className="col-md-4 text-center d-flex"
								data-aos="fade-up"
								key={project.id}
							>
								<div href="#" className="services-1">
									<span className="icon float-left">
										<i className="icon-folder-open-o"></i>
									</span>
									<div className="desc">
										<h3 className="mb-5">{project.name}</h3>
										<p className="text-left">
											{project.description}
										</p>
										<span>{project.tech}</span>
										{project.link ? (
											<a
												href={project.link}
												target="_blank"
												rel="noopener noreferrer"
											>
												<span className="icon float-right">
													<i
														className="icon-open_in_new"
														style={{
															fontSize: '1rem',
														}}
													></i>
												</span>
											</a>
										) : null}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>
		</React.Fragment>
	);
};

export default Projects;
